import WhatsAppIcon from '@/components/icons/WhatsAppIcon'
import { useLiens } from '@/hooks/useContent'

export default function WhatsAppButton() {
  const liens = useLiens()
  return (
    <a
      href={liens.whatsapp}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Nous écrire sur WhatsApp"
      className="animate-whatsapp-pulse fixed right-4 bottom-8 z-50 w-14 h-14 bg-green-500 hover:bg-green-600 rounded-full shadow-xl flex items-center justify-center transition-colors active:scale-95"
    >
      <WhatsAppIcon size={28} />
    </a>
  )
}
